import Phaser from 'phaser';

import './css/style.css';

import RoundRectanglePlugin from 'phaser3-rex-plugins/plugins/roundrectangle-plugin.js';
import TagTextPlugin from 'phaser3-rex-plugins/plugins/tagtext-plugin.js';
import SliderPlugin from 'phaser3-rex-plugins/plugins/slider-plugin.js';

import Boot from './js/scenes/Boot.js';
import Preloader from './js/scenes/Preloader.js';
import Menu from './js/scenes/Menu.js';
import Video from './js/scenes/Video.js';
import Schema from './js/scenes/Schema.js';
import Fin from './js/scenes/Fin.js';

//Création du jeu
var game;

window.onload = function () {
    var isMobile = /Mobi|Android/i.test(navigator.userAgent) || Phaser.Input.Touch.enabled;
    var config = {
        autoResize: true,
        width: 1920,
        height: 1080,
        backgroundColor: '#FFFFFF',
        type: Phaser.AUTO,
        parent: "game",
        scale: {
            mode: isMobile ? Phaser.Scale.FIT : Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH
        },
        dom: {
            createContainer: true
        },
        plugins: {
            global: [{
                key: 'rexRoundRectanglePlugin',
                plugin: RoundRectanglePlugin,
                start: true
            },
            {
                key: 'rexTagTextPlugin',
                plugin: TagTextPlugin,
                start: true
            }, {
                key: 'rexSlider',
                plugin: SliderPlugin,
                start: true
            }]
        },
        fps: {
            target: 30,
            forceSetTimeOut: true
        },
        scene: [Boot, Preloader, Menu, Video, Schema, Fin]
    };

    game = new Phaser.Game(config);

    console.log('  __       __|  __  ');
    console.log('__)  (__| (__| (__) ');
    console.log('        |           ');

    game.scene.start("Boot");
}